/**
 * SlopeAnalysisPlugin — slope/aspect switching plugin.
 *
 * Manages the state for toggling between elevation, slope, and aspect
 * rendering modes on the terrain layer. Delegates the actual rendering
 * to `terrainColorMap.ts` via the Giro3D adapter.
 */

export type AnalysisMode = 'elevation' | 'slope' | 'aspect';

export interface SlopeAnalysisState {
  readonly mode: AnalysisMode;
  readonly slopeUnit: 'degrees' | 'percent';
}

export const INITIAL_SLOPE_STATE: SlopeAnalysisState = {
  mode: 'elevation',
  slopeUnit: 'degrees',
};

export function nextMode(current: AnalysisMode): AnalysisMode {
  const cycle: AnalysisMode[] = ['elevation', 'slope', 'aspect'];
  const idx = cycle.indexOf(current);
  return cycle[(idx + 1) % cycle.length];
}
